import { render } from "./ResponsiveGrid.vue?vue&type=template&id=309b144d&scoped=true"
import script from "./ResponsiveGrid.vue?vue&type=script&lang=js"
export * from "./ResponsiveGrid.vue?vue&type=script&lang=js"

import "./ResponsiveGrid.vue?vue&type=style&index=0&id=309b144d&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309b144d"]])

export default __exports__